<template>
  <div>
    <div class="container-fluid p-0">
      <div class="row g-0">
        <div class="col-xl-9">
          <div class="auth-full-bg pt-lg-5 p-4">
            <div class="bg-overlay"></div>
          </div>
        </div>
        <!-- end col -->

        <div class="col-xl-3">
          <div class="auth-full-page-content p-4 p-xxl-5 p-md-3">
            <div class="w-100">
              <div class="d-flex flex-column h-100">
                <div class="mb-4 mb-md-5">
                  <img
                    src="https://uniweb2.unicampo.coop.br/assets/images/logo-unicampo-pequena.png"
                    height="60"
                  />
                </div>
                <div class="my-auto">
                  <div>
                    <h5 class="text-primary">Cadastro</h5>
                    <p class="text-muted">
                      Para que você tenha acesso ao Portal Unicampo, é
                      nescessário o preenchimento de alguns dados.
                    </p>
                    <p class="text-muted mt-2">
                      Para começar, informe o seu e-mail no campo abaixo
                    </p>
                    <div>
                      <div @input="desabilitaContinuar()">
                        <email
                          class="col-12"
                          v-on:emitindoEmail="atribuiEmail"
                          :validado="null"
                          inputText="Digite um E-mail"
                          label="E-mail"
                        />
                      </div>
                      <span
                        class="text-warning fw-bold div-clickable text-decoration-underline"
                        @click="verificaEmail()"
                      >
                        Verficar E-mail <i class="fas fa-exclamation-circle" />
                      </span>
                      <b-spinner
                        small
                        class="ms-2"
                        v-if="loadingVerificar"
                      ></b-spinner>
                    </div>
                    <div v-if="showFormulario">
                      <cpf
                        class="col-12 mt-2"
                        v-on:emitindoCPF="atribuiCpf"
                        inputText="Informe seu CPF"
                        :validado="null"
                        label="CPF"
                      />
                      <b-form-group
                        label="Data de Nascimento"
                        class="col-md-12"
                      >
                        <b-form-input
                          v-model="dados.nascimento"
                          v-mask="'##/##/####'"
                          :state="state"
                        />
                      </b-form-group>
                      <!-- <b-form-group
                        label="Data de Nascimento"
                        class="col-md-12"
                      >
                        <date-picker
                          v-model="dados.nascimento"
                          value-type="YYYY-MM-DD"
                          format="DD/MM/YYYY"
                          type="year"
                          panel-change="type: month"
                          append-to-body
                        />
                      </b-form-group> -->
                      <telefone
                        class="col-md-12 mt-2"
                        v-on:emitindoTelefone="atribuiTelefone"
                        :validado="null"
                        label="Telefone"
                      />
                    </div>
                  </div>
                </div>

                <div class="row mb-0">
                  <div class="col-6 text-right">
                    <router-link to="/login">
                      <button
                        class="btn btn-secondary bg-soft w-md waves-effect waves-light"
                      >
                        Cancelar
                      </button>
                    </router-link>
                  </div>
                  <div class="col-6 text-end">
                    <button
                      class="btn btn-primary w-md waves-effect waves-light"
                      :disabled="verificaContinuar()"
                      v-b-modal.modal-informacoes
                    >
                      Continuar <i class="far fa-arrow-alt-circle-right" />
                    </button>
                  </div>
                </div>

                <div class="mt-4 mt-md-5 text-center">
                  <p class="mb-0">
                    © {{ new Date().getFullYear() }} UNICAMPO. Todos os direitos
                    Reservados.
                  </p>
                </div>

                <b-modal
                  id="modal-informacoes"
                  centered
                  title="CONFIRA OS DADOS ABAIXO"
                  hide-footer
                >
                  <div>
                    <p class="my-1 text-warning">
                      <i class="fas fa-thumbs-up" /> Confira os dados abaixo:
                    </p>
                    <div class="d-flex justify-content-between mt-2">
                      <label
                        >Nome:<br />
                        <strong>{{ dados.nome }}</strong></label
                      >
                      <label
                        >Email:<br />
                        <strong>{{ dados.email }}</strong></label
                      >
                    </div>
                    <div class="d-flex justify-content-between mt-2">
                      <label
                        >Data de Nascimento:<br />
                        <strong>{{ dados.nascimento }}</strong></label
                      >
                      <label
                        >CPF:<br />
                        <strong>{{ dados.cpf }}</strong></label
                      >
                      <label
                        >Tefone:<br />
                        <strong>{{ dados.telefone }}</strong></label
                      >
                    </div>
                    <p class="my-2 font-size-15 text-warning">
                      <i class="mdi mdi-account-alert-outline" /> Em caso de
                      correção, clique em Voltar. Clicando em continuar, você
                      estará confirmando a veracidade de todos os dados.
                    </p>
                    <div class="d-flex justify-content-between mt-3">
                      <div>
                        <b-form-checkbox
                          v-model="dadosConfirmados"
                          :value="true"
                          :unchecked-value="false"
                          plain
                        >
                          Dados estão corretos?
                        </b-form-checkbox>
                      </div>
                      <div class="text-right">
                        <button
                          class="btn btn-secondary bg-soft w-md"
                          @click="$bvModal.hide('modal-informacoes')"
                        >
                          <i class="far fa-arrow-alt-circle-left" /> Voltar
                        </button>
                      </div>
                      <div class="text-end">
                        <button
                          class="btn btn-primary w-md"
                          :disabled="!dadosConfirmados"
                          @click="$bvModal.hide('modal-informacoes')"
                          v-b-modal.modal-termosdeUso
                        >
                          Continuar <i class="far fa-arrow-alt-circle-right" />
                        </button>
                      </div>
                    </div>
                  </div>
                </b-modal>

                <b-modal
                  id="modal-termosdeUso"
                  size="lg"
                  scrollable
                  centered
                  title="TERMOS DE USO E POLÍTICA DE PRIVACIDADE"
                  hide-footer
                >
                  <div>
                    <p style="text-align: justify">
                      A Cooperativa de Trabalho dos Profissionais de Agronomia
                      Ltda. Unicampo (“Unicampo”) estabelece nestes Termos de
                      Uso e Política de Privacidade as condições para utilização
                      do aplicativo Unimob por meio dos quais o Usuário poderá
                      acessar os serviços e conteúdos disponibilizados pela
                      Unicampo, de forma a esclarecer as obrigações e
                      responsabilidades de seus Usuários.
                    </p>
                    <p style="text-align: justify">
                      Estes Termos de uso e política de privacidade consistem
                      nos termos e nas condições abaixo.<br />
                      Certifique-se de estar sempre informado sobre quaisquer
                      mudanças.
                    </p>
                    <p style="text-align: justify">
                      1. DEFINIÇÕES: <br />
                      Para os fins destes Termos de Uso e Política de
                      Privacidade, consideram-se: <br />
                      1.1. Endereço MAC (Media Access Control): é um endereço
                      físico associado à interface de comunicação, que conecta
                      um dispositivo à rede, o código atribuído a um Terminal de
                      uma rede para permitir sua identificação, definido segundo
                      parâmetros internacionais. <br />
                      1.2. Senha: conjunto de caracteres que podem ser
                      constituídos por letras e/ou números, com a finalidade de
                      verificar a identidade do Usuário para acesso ao
                      Aplicativo. <br />
                      1.3. Aplicativo: aplicativo da Unicampo por meio do qual o
                      Usuário acessa os serviços e conteúdos disponibilizados
                      pela Unicampo.<br />
                      1.4. Usuários (ou “Usuário”, quando individualmente
                      considerado): todas as pessoas físicas que utilizarão o
                      Aplicativo, maiores de 18 (dezoito) anos ou emancipadas e
                      totalmente capazes de praticar os atos da vida civil ou os
                      absolutamente ou relativamente incapazes devidamente
                      representados ou assistidos.
                    </p>
                    <p style="text-align: justify">
                      2. ACEITE DOS TERMOS DE USO E POLÍTICA DE PRIVACIDADE:
                      <br />
                      Ao acessar o Aplicativo, o Usuário concorda e aceita
                      integralmente as disposições destes Termos de Uso e
                      Política de Privacidade.
                    </p>
                    <p style="text-align: justify">
                      3. PERMISSÕES: <br />
                      O Aplicativo pode utilizar os seguintes recursos de seu
                      aparelho celular:<br />
                      (i) Local: Localização aproximada (com base na rede),
                      localização precisa (GPS e com base na rede).<br />
                      (ii) Fotos/mídia/arquivos: Ler conteúdo do armazenamento
                      USB, alterar ou excluir conteúdo de armazenamento USB.<br />
                      (iii) Armazenamento: Ler conteúdo do armazenamento USB,
                      alterar ou excluir conteúdo de armazenamento USB.<br />
                      (iv) Câmera: Tirar fotos e gravar vídeos.<br />
                      (v) Outras: Ver conexões de rede, controlar lanterna,
                      acesso total à rede.<br />
                    </p>
                    <p style="text-align: justify">
                      4. CADASTRO: <br />
                      o Aplicativo pode possuir tanto áreas de conteúdo aberto
                      como de conteúdo e/ou serviços restritos. Para que o
                      Usuário acesse conteúdo e/ou serviços restritos, será
                      necessário fornecer informação de login e senha,
                      fornecidos pela Unicampo. <br />
                      4.1. O Usuário se responsabiliza pela precisão e
                      veracidade dos dados informados e reconhece que a
                      inconsistência destes poderá implicar a impossibilidade de
                      acessar e utilizar o Aplicativo.<br />
                      4.2. O Usuário assume inteira responsabilidade pela
                      guarda, sigilo e boa utilização do login e senhas
                      cadastrados, isentando Unicampo de qualquer
                      responsabilidade. <br />
                      4.3. O login e Senha só poderão ser utilizados pelo
                      Usuário cadastrado, sendo expressamente proibido o
                      compartilhamento de login e/ou Senha com quaisquer
                      terceiros. <br />
                      4.4. O Usuário poderá, a qualquer momento, excluir o
                      Aplicativo, ficando ressalvada a guarda pela Unicampo das
                      informações e/ou dados cuja manutenção seja a eles imposta
                      em razão de obrigações legais e/ou regulatórias ou, ainda,
                      cuja a manutenção seja necessária para cumprimento de
                      ordem judicial, no âmbito de processos judiciais e/ou
                      administrativos e questionamento de terceiros decorrentes
                      das atividades desempenhadas pelo Usuário no Aplicativo.
                    </p>
                    <p style="text-align: justify">
                      5. PRIVACIDADE: <br />
                      5.1. INFORMAÇÕES DOS USUÁRIOS: <br />
                      5.1.1. As Informações dos Usuários são coletadas,
                      armazenadas, tratadas,processadas e utilizadas pela
                      Unicampo com as seguintes finalidades:<br />
                      (i) desenvolver, manter e aperfeiçoar os recursos e
                      funcionalidades do Aplicativo;<br />
                      (ii) possibilitar o acesso e o uso dos recursos e
                      funcionalidades do Aplicativo pelos Usuários;<br />
                      (iii) analisar o desempenho do Aplicativo, medir a
                      audiência do Aplicativo, verificar os hábitos de navegação
                      dos Usuários no Aplicativo;<br />
                      (iv) análises relacionadas à segurança do Aplicativo,
                      aperfeiçoamento e desenvolvimento de ferramentas
                      antifraude;<br />
                      (v) melhorar as experiências de navegação dos Usuários no
                      Aplicativo;<br />
                      5.1.2. A Unicampo preserva a privacidade dos Usuários e
                      não compartilham seus dados e informações com terceiros
                      não relacionados a atividade da Unicampo, salvo mediante
                      consentimento do próprio Usuário, por força de lei ou
                      ordem judicial.
                    </p>
                    <p style="text-align: justify">
                      6. VIOLAÇÕES: <br />
                      O Usuário não poderá praticar as seguintes ações em razão
                      ou por meio da utilização do Aplicativo: <br />
                      (i) prática de quaisquer atos ilícitos e/ou violação da
                      legislação vigente;<br />
                      (ii) atos contrários à moral e aos bons costumes;<br />
                      (iii) carregamento, envio e/ou transmissão de qualquer
                      conteúdo de cunho erótico, pornográfico, obsceno,
                      difamatório ou calunioso ou que façam apologia ao crime,
                      uso de drogas, consumo de bebidas alcoólicas ou de
                      produtos fumígenos, violência física ou moral;<br />
                      (iv) carregamento, envio e/ou transmissão de qualquer
                      conteúdo que promova ou incite o preconceito (inclusive de
                      origem, raça, sexo, cor, orientação sexual e idade) ou
                      qualquer forma de discriminação, bem como o ódio ou
                      atividades ilegais; <br />
                      (v) ameaça, coação, constrangimento físico ou moral aos
                      demais Usuários;<br />
                      (vi) violação de direitos de terceiros; <br />
                      (vii) violação dos direitos de sigilo e privacidade
                      alheios; <br />
                      (viii) atos que causem ou propiciem a contaminação ou
                      prejudiquem quaisquer equipamentos da Unicampo e/ou de
                      terceiros, inclusive por meio de vírus, trojans, malware,
                      worm, bot, backdoor, spyware, rootkit, ou por quaisquer
                      outros dispositivos que venham a ser criados; <br />
                      (ix) praticar quaisquer atos que direta ou indiretamente,
                      no todo ou em parte, possam causar prejuízo a Unicampo, a
                      qualquer Usuário e/ou a quaisquer terceiros;
                    </p>
                    <p style="text-align: justify">
                      7. RESPONSABILIDADES: <br />
                      O Usuário é exclusivamente responsável: <br />
                      (i) por todos e quaisquer atos ou omissões por ele
                      realizados a partir de seu acesso à Internet e ao
                      Aplicativo;<br />
                      (ii) por todo e qualquer conteúdo por ele carregado,
                      enviado e/ou transmitido ao Aplicativo; <br />
                      (iii) pela reparação de todos e quaisquer danos, diretos
                      ou indiretos (inclusive decorrentes de violação de
                      quaisquer direitos de outros usuários, de terceiros,
                      inclusive direitos de propriedade intelectual, de sigilo e
                      de personalidade), que sejam causados a Unicampo e/ou a
                      qualquer outro Usuário, ou, ainda, a qualquer terceiro,
                      inclusive em virtude do descumprimento do disposto nestes
                      Termos de Uso e Política de Privacidade ou de qualquer ato
                      praticado a partir de seu acesso à Internet, e ao
                      Aplicativo.<br />
                      7.1. Caso o Usuário descumpra qualquer disposição destes
                      Termos de Uso e Política de Privacidade ou disposição
                      legal, sem prejuízo de outras medidas, a Unicampo poderá,
                      por si ou por terceiros, a qualquer tempo, a seu exclusivo
                      critério, sem necessidade de qualquer aviso ou notificação
                      prévia ou posterior a qualquer Usuário ou a qualquer
                      terceiro, sob qualquer meio ou forma, sem prejuízo de
                      iniciar as medidas legais cabíveis, suspender ou limitar o
                      acesso ao Aplicativo, encerrar a conta de qualquer Usuário
                      e/ou tomar outras providências que entender necessárias
                      para o cumprimento destes Termos de Uso e Política de
                      Privacidade e para o bom funcionamento do Aplicativo, a
                      qualquer tempo.
                    </p>
                    <p style="text-align: justify">
                      8. PROPRIEDADE INTELECTUAL: <br />
                      8.1. Pertencem a Unicampo: <br />
                      (i) todo e qualquer software, aplicativo ou funcionalidade
                      empregado pela Unicampo referente ao Aplicativo;<br />
                      (ii) a identidade visual (incluindo o projeto de arte
                      gráfico-visual de quaisquer de suas páginas); <br />
                      (iii) o nome empresarial, marca, nome de domínio, slogan
                      ou expressão de propaganda ou qualquer sinal distintivo de
                      sua titularidade inserido no Aplicativo;<br />
                      (iv) todo e qualquer conteúdo criado e produzido pela
                      Unicampo, por si ou por terceiros, os quais não poderão
                      ser usados, sob qualquer meio ou forma, pelos Usuários.<br />
                      8.2. Nas hipóteses em que o Aplicativo permitir o envio
                      e/ou transmissão de Conteúdos pelo Usuário, o Usuário
                      concede autorização gratuita, não exclusiva, irrevogável e
                      irretratável a Unicampo para utilizar todos e quaisquer
                      direitos intelectuais (inclusive autorais e conexos)
                      patrimoniais sobre quaisquer Conteúdos, enviados e/ou
                      transmitidos pelo Usuário ao Aplicativo, sob qualquer meio
                      ou forma, a seu exclusivo critério, sem qualquer restrição
                      ou limitação de qualquer natureza. O Usuário declara e
                      garante que os Conteúdos não infringem direitos de
                      terceiros e que obteve todas as autorizações eventualmente
                      necessárias para possibilitar o uso destes pela Unicampo.
                    </p>
                    <p style="text-align: justify">
                      9. TOLERÂNCIA: <br />
                      A tolerância quanto ao eventual descumprimento de
                      quaisquer das disposições destes Termos de Uso e Política
                      de Privacidade por qualquer Usuário não constituirá
                      renúncia ao direito de exigir o cumprimento da obrigação,
                      nem perdão, nem alteração do que consta aqui previsto.
                    </p>
                    <p style="text-align: justify">
                      10. ALTERAÇÕES DO ACESSO E DOS TERMOS DE USO E POLÍTICAS
                      DE PRIVACIDADE: <br />
                      A Unicampo, a qualquer tempo, a seu exclusivo critério e
                      sem necessidade de qualquer aviso prévio ou posterior a
                      qualquer Usuário ou terceiros, poderá: <br />
                      (i) suspender, cancelar ou interromper o acesso ao
                      Aplicativo <br />
                      (ii) remover, alterar e/ou atualizar no todo ou em parte o
                      Aplicativo bem como seus respectivos conteúdos e/ou Termos
                      de Uso e Política de privacidade. <br />
                      Qualquer alteração e/ou atualização destes Termos de Uso e
                      Política de Privacidade passará a vigorar a partir da data
                      de sua publicação no Aplicativo e deverá ser integralmente
                      observada pelos Usuários.
                    </p>
                    <p style="text-align: justify">
                      11. LEGISLAÇÃO E FORO: <br />
                      Estes Termos de Uso e Política de Privacidade são regidos
                      de acordo com a legislação brasileira. Quaisquer disputas
                      ou controvérsias oriundas de quaisquer atos praticados no
                      âmbito da utilização do Aplicativo pelos Usuários,
                      inclusive com relação ao descumprimento dos Termos de Uso
                      e Política de Privacidade ou pela violação dos direitos do
                      Unicampo, de outros Usuários e/ou de terceiros, inclusive
                      direitos de propriedade intelectual, de sigilo e de
                      personalidade, serão processadas na Comarca de Maringá
                      estado do Paraná.
                    </p>
                  </div>
                  <div class="d-flex justify-content-between mt-3">
                    <div>
                      <b-form-checkbox
                        v-model="termosDeUso"
                        :value="true"
                        :unchecked-value="false"
                        plain
                      >
                        Eu li e concordo com os Termos e Condições
                      </b-form-checkbox>
                    </div>
                    <div class="text-end">
                      <button
                        class="btn btn-secondary bg-soft w-md"
                        @click="$bvModal.hide('modal-termosdeUso')"
                        v-b-modal.modal-informacoes
                      >
                        <i class="far fa-arrow-alt-circle-left" /> Voltar
                      </button>
                    </div>
                    <div class="text-end">
                      <button
                        class="btn btn-success w-md"
                        :disabled="!termosDeUso"
                        @click="cadastrarUsuario()"
                      >
                        <i class="bx bx-check-circle" /> Finalizar
                        <b-spinner
                          small
                          class="ms-2"
                          v-if="loadingCadastrar"
                        ></b-spinner>
                      </button>
                    </div>
                  </div>
                </b-modal>
              </div>
            </div>
          </div>
        </div>
        <!-- end col -->
      </div>
      <!-- end row -->
    </div>
    <!-- end container-fluid -->
  </div>
</template>

<script>
import email from "@/components/formulario/email-input";
import cpf from "@/components/formulario/cpf-input";
import telefone from "@/components/formulario/telefone-input";

export default {
  components: { email, cpf, telefone },
  layout: "empty",
  data() {
    return {
      dados: {
        email: "",
        cpf: "",
        nascimento: "",
        telefone: "",
        nome: "",
      },
      showFormulario: false,
      emailVerificado: false,
      dadosConfirmados: false,
      termosDeUso: false,
      habilitarContinuar: false,
      loadingVerificar: false,
      loadingCadastrar: false,
    };
  },
  computed: {
    state() {
      if (this.dados.nascimento.length >= 10) {
        return true;
      }
      return null;
    },
  },
  methods: {
    atribuiEmail(email) {
      this.dados.email = email;
    },
    atribuiCpf(cpf) {
      this.dados.cpf = cpf;
    },
    atribuiTelefone(telefone) {
      this.dados.telefone = telefone;
    },
    verificaEmail() {
      if (!this.dados.email) {
        this.$tools.alerta("Por favor, digite um e-mail válido", "warning");
        return;
      }
      this.dados.email = this.dados.email.toLowerCase();
      this.loadingVerificar = true;
      this.$http
        .post("api/auth/verificarEmail", {
          email: this.dados.email,
        })
        .then((response) => {
          this.dados.nome = response.data.nm_preferido;
          this.emailVerificado = true;
          this.showFormulario = true;
          this.$tools.alerta("E-mail verificado com sucesso", "success");
          this.loadingVerificar = false;
        })
        .catch((err) => {
          this.$tools.alerta(err.response.data.message, "error");
          this.loadingVerificar = false;
        });
    },
    cadastrarUsuario() {
      this.loadingCadastrar = true;

      this.$http
        .post("api/auth/register", {
          email: this.dados.email,
          cpf: this.dados.cpf.replace(/\W/g, ""),
          dataNascimento: this.dados.nascimento,
          ddd: this.dados.telefone.substr(1.2),
          telefone: this.dados.telefone.substr(5),
        })
        .then(() => {
          this.$bvModal.hide("modal-termosdeUso");
          this.emailVerificado = true;
          this.showFormulario = true;
          this.$tools.alerta("Cadastro criado com sucesso", "success");
          this.$router.push("/login");
        })
        .catch((err) => {
          this.$tools.alerta(err.response.data.message, "error");
          this.$bvModal.hide("modal-termosdeUso");
        });
    },
    verificaContinuar() {
      if (
        this.dados.email == "" ||
        this.dados.cpf == "" ||
        this.dados.nascimento == "" ||
        this.dados.telefone == "" ||
        this.emailVerificado == false
      ) {
        return true;
      }
      return false;
    },
    desabilitaContinuar() {
      this.emailVerificado = false;
      this.dados.email = "";
      this.verificaContinuar();
    },
  },
};
</script>